import { Input, InputProps } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { baseStyledInputStyles } from '../utils/formUtils'

interface Props extends InputProps {
  defaultDebounceTime?: number
  value: string | undefined
  setValue: (newValue: string) => void
  isStyled?: boolean
}
export const DebouncedInputText: React.FC<Props> = ({
  defaultDebounceTime,
  value,
  setValue,
  isStyled,
  ...rest
}) => {
  const [debouncedTerm, setDebouncedTerm] = useState(value)
  const debounceTime = defaultDebounceTime ?? 600

  useEffect(() => {
    const timer = setTimeout(() => setValue(debouncedTerm ?? ''), debounceTime)
    return () => clearTimeout(timer)
  }, [debouncedTerm])

  return (
    <Input
      variant={'outline'}
      fontSize="md"
      value={debouncedTerm}
      onChange={(e) => setDebouncedTerm(e.target.value)}
      {...rest}
      {...(isStyled ? baseStyledInputStyles : {})}
    />
  )
}
